import { useMemo } from 'react';

import { getHelpUrl } from '@change-corgi/config/help';
import { translationKey, type TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocale } from '#src/app/shared/hooks/l10n';

type Props = {
	useDonationLanguage: boolean;
};

type Result = ModelHookResult<{
	termsOfServiceLink: string;
	termsOfServiceLinkText: string;
	privacyPolicyLink: string;
	privacyPolicyLinkText: string;
	policyInfoText: TranslationKey;
}>;

export function usePolicyInfo({ useDonationLanguage }: Props): Result {
	const locale = useLocale();
	const { translate } = useI18n();

	const { termsOfServiceLink, termsOfServiceLinkText } = useMemo(() => {
		if (!useDonationLanguage) {
			return {
				termsOfServiceLink: 'https://www.change.org/policies/terms-of-service#6',
				termsOfServiceLinkText: translate('corgi.payments.policy_info.terms_of_service'),
			};
		}

		return {
			termsOfServiceLink: getHelpUrl(locale, 'foundation-donation-terms-of-service'),
			termsOfServiceLinkText: translate('corgi.payments.policy_info.terms_of_service_donation'),
		};
	}, [useDonationLanguage, translate, locale]);

	return {
		data: {
			privacyPolicyLink: 'https://www.change.org/policies/privacy',
			privacyPolicyLinkText: translate('corgi.payments.policy_info.privacy_policy'),
			termsOfServiceLink,
			termsOfServiceLinkText,
			policyInfoText: translationKey('corgi.payments.policy_info.description'),
		},
	};
}
